/**
 * Defense-in-depth scrubber for SVG markup from our own backend
 * (`drawCypherSubgraphServer`). Never the primary trust boundary.
 * Strips `<script>` blocks, `on*=` handlers, and `javascript:` URLs.
 */
export function sanitizeSubgraphSvg(svg: string): string {
  return svg
    .replace(/<\s*script[\s\S]*?<\s*\/\s*script\s*>/gi, '')
    .replace(/\son[a-z]+\s*=\s*"[^"]*"/gi, '')
    .replace(/\son[a-z]+\s*=\s*'[^']*'/gi, '')
    .replace(/\son[a-z]+\s*=\s*[^\s>]+/gi, '')
    .replace(/javascript:/gi, '')
}
